export const types = {
  SET_USER_SESSIONS: 'SET_USER_SESSIONS',
};
